import middleware from './middleware';
import helpers from './helpers';
import selectors from './selectors';
import accessors from './accessors';
import actions from './actions';
import reducers from './reducers';
import operations from './operations';
import actionTypes from './constants/action-types';

export default {
  actionTypes,
  selectors,
  accessors,
  middleware,
  operations,
  helpers,
  actions,
  reducers,
};
